/**
 * Buy Now — 事件委托版
 *
 * 为什么不是直接给按钮绑定 / 不用 DOMContentLoaded：
 * 集合页的快捷视图弹框是 fetch + innerHTML 注入的（theme.js 的 renderModalContent），
 * innerHTML 不会执行 <script>，而且那时 DOMContentLoaded 早已触发。
 * 所以这里挂 document 级委托，点击时用 closest() 现场匹配 ——
 * 商品页、任意卡片的快捷视图都能用，也不会再出现"只绑到页面第一个按钮"的问题。
 *
 * Loaded globally via layout/theme.liquid.
 */
(function () {
    'use strict';

    var SUBMIT_SELECTOR = '.product-form-buy-now__submit';

    /** 弹框里的按钮只在自己的弹框内找选项，避免同页多个弹框互相串台 */
    function getScope(button) {
        return button.closest('loess-modal-product') || document;
    }

    function getSelectedOptions(scope) {
        var options = [];

        scope.querySelectorAll('fieldset input[type="radio"]:checked').forEach(function (input) {
            options.push(input.value);
        });

        scope.querySelectorAll('select[name^="options"]').forEach(function (select) {
            options.push(select.value);
        });

        return options;
    }

    /**
     * 优先用当前 section 输出的变体 JSON：
     * type="application/json" 的 script 不是可执行脚本，能安全穿过 innerHTML。
     * ShopifyAnalytics 在集合页上是"集合"的数据，拿不到商品变体，只能当兜底。
     */
    function getVariants(scope) {
        var dataElement = scope.querySelector('script[id^="ProductVariantData-"]');

        if (dataElement) {
            try {
                var variants = JSON.parse(dataElement.textContent);
                if (variants && variants.length) return variants;
            } catch (error) {
                console.warn('Buy Now: ProductVariantData 解析失败，回退到 ShopifyAnalytics', error);
            }
        }

        var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        return (meta && meta.product && meta.product.variants) || [];
    }

    function getSelectedVariantId(scope) {
        var variants = getVariants(scope);
        if (!variants.length) return null;

        // 单变体商品只有一个 id，不需要匹配标题
        if (variants.length === 1) return variants[0].id;

        var selectedOptions = getSelectedOptions(scope);
        if (!selectedOptions.length) return null;

        var title = selectedOptions.join(' / ');
        var matched = variants.filter(function (variant) {
            return variant.public_title === title || (variant.name && variant.name.indexOf(title) !== -1);
        })[0];

        return matched ? matched.id : null;
    }

    function addAndCheckout(button) {
        var form = button.closest('form');
        if (!form) return;

        var formData = new FormData(form);
        var variantInput = form.querySelector('input[name="id"]');
        var selectedVariantId = getSelectedVariantId(getScope(button));

        // 变体选择器会同步更新隐藏的 id input；不一致时以页面上实际选中的变体为准
        if (selectedVariantId && variantInput && String(selectedVariantId) !== String(variantInput.value)) {
            formData.set('id', selectedVariantId);
        }

        var spinner = button.querySelector('.spinner');
        button.setAttribute('disabled', 'disabled');
        if (spinner) spinner.classList.remove('hide');

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
        }).then(function (response) {
            if (!response.ok) {
                return response.json().catch(function () {
                    return {};
                }).then(function (error) {
                    throw new Error(error.description || error.message || 'Add to cart failed: ' + response.status);
                });
            }
            return response.json();
        }).then(function () {
            // 带上 routes.root 前缀，兼容多语言 / 多市场（/en/checkout）
            window.location.href = window.Shopify.routes.root + 'checkout';
        }).catch(function (error) {
            console.error('Buy Now error:', error);
            button.removeAttribute('disabled');
            if (spinner) spinner.classList.add('hide');
        });
    }

    document.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var button = target.closest(SUBMIT_SELECTOR);
        if (!button || button.disabled) return;

        event.preventDefault();
        addAndCheckout(button);
    });
})();
